import PropTypes from "prop-types"
import React from "react"

import Button from "src/components/Button"

import HoldReasonPopover from "./HoldReasonPopover"

// TODO(i18n): centralize these labels with JobStatusBadge / LOCK_TOOLTIP when the FE i18n sweep lands.
const TRANSITION_CONFIG = {
  start: {
    label: "Start Work",
    variant: "primary",
    icon: "fa-play text-lg",
  },
  complete: {
    label: "Mark Complete",
    variant: "primary",
  },
  resume: {
    label: "Resume",
    variant: "primary",
    icon: "fa-play text-lg",
  },
  reopen: { label: "Reopen", variant: "secondary", icon: "fa-replay" },
}

// One primary transition is rendered at a time, in this priority order. Hold is
// a separate, secondary affordance that can appear alongside a primary one (an
// in_progress job exposes both `complete` and `hold` — both render).
const PRIMARY_PRIORITY = ["start", "complete", "resume", "reopen"]

const JobTransitionButton = ({ job, onTransition, onHold, disabled }) => {
  const permitted = job.permittedTransitions ?? []
  const primary = PRIMARY_PRIORITY.find((name) => permitted.includes(name))
  const showHold = permitted.includes("hold")

  if (!primary && !showHold) return null

  return (
    <>
      {showHold && (
        <HoldReasonPopover
          triggerLabel="Hold"
          onHold={onHold}
          disabled={disabled}
        />
      )}
      {primary && (
        <Button
          type="button"
          small
          variant={TRANSITION_CONFIG[primary].variant}
          icon={TRANSITION_CONFIG[primary].icon}
          disabled={disabled}
          onClick={() => onTransition(primary)}
        >
          {TRANSITION_CONFIG[primary].label}
        </Button>
      )}
    </>
  )
}

JobTransitionButton.propTypes = {
  job: PropTypes.shape({
    permittedTransitions: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  onTransition: PropTypes.func.isRequired,
  onHold: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

JobTransitionButton.defaultProps = {
  disabled: false,
}

export default JobTransitionButton
